import { Button } from "@/components/ui/button.tsx"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { ComponentChildren } from "preact"

interface PendingTaskConfirmDialogProps {
  open: boolean
  /** Disable the buttons while the completion/assignment requests are in flight. */
  busy?: boolean
  /** Description of the existing pending task(s), rendered above the choices. */
  children?: ComponentChildren
  onCompleteExisting: () => void
  onKeepExisting: () => void
  onCancel: () => void
  className?: string
}

/**
 * Shown when assigning a task onto deduction(s) that already carry a pending task: the user
 * chooses whether the existing pending task(s) should be marked complete alongside the new
 * assignment, kept open next to it, or whether to abort the assignment entirely.
 */
export function PendingTaskConfirmDialog({
  open,
  busy,
  children,
  onCompleteExisting,
  onKeepExisting,
  onCancel,
  className,
}: PendingTaskConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={dialog_open => {
        if (!dialog_open) onCancel()
      }}>
      <DialogContent className={`sm:max-w-[440px] ${className ?? ""}`}>
        <DialogHeader>
          <DialogTitle>Pending task already assigned</DialogTitle>
        </DialogHeader>
        <div className="text-sm space-y-2">{children}</div>
        <div className="flex flex-col gap-2 mt-2">
          <Button variant="tertiary" disabled={busy} onClick={onCompleteExisting}>
            Mark existing complete & assign
          </Button>
          <Button variant="outline" disabled={busy} onClick={onKeepExisting}>
            Keep existing & assign
          </Button>
          <Button variant="ghost" disabled={busy} onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
